import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "._-0NvO{height:auto;position:relative;width:100%}[dir] ._-0NvO{margin-bottom:25px}@media only screen and (max-width:640px){[data-query=media] ._-0NvO{height:30px}[dir] [data-query=media] ._-0NvO{padding-bottom:8px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._-0NvO{height:30px}[dir] [data-query=container] ._-0NvO{padding-bottom:8px}}}@container (width < 640px){[data-query=container] ._-0NvO{height:30px}[dir] [data-query=container] ._-0NvO{padding-bottom:8px}}._28d-o{color:var(--ricos-settings-text-color,#000);font-size:16px;font-weight:300;line-height:18px;position:absolute;top:calc(50% - 9px)}[dir=ltr] ._28d-o{left:0}[dir=rtl] ._28d-o{right:0}@media only screen and (max-width:640px){[data-query=media] ._28d-o{top:calc(50% - 18px)}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._28d-o{top:calc(50% - 18px)}}}@container (width < 640px){[data-query=container] ._28d-o{top:calc(50% - 18px)}}.SAJ-g{display:inline-block;height:auto;width:50%}[dir=ltr] .SAJ-g{direction:rtl}[dir=rtl] .SAJ-g{direction:ltr}.UkEEo{box-sizing:border-box;height:20px;position:absolute;top:0;width:20px}[dir] .UkEEo{border:1px solid #c9c9c9;border-radius:var(--ricos-settings-small-buttons-border-radius,28px);cursor:pointer}[dir=ltr] .UkEEo{right:0}[dir=rtl] .UkEEo{left:0}@media only screen and (max-width:640px){[data-query=media] .UkEEo{height:20px;width:20px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .UkEEo{height:20px;width:20px}}}@container (width < 640px){[data-query=container] .UkEEo{height:20px;width:20px}}[dir] .kS0mn{margin-bottom:7px}@media only screen and (max-width:640px){[dir] [data-query=media] .kS0mn{margin-bottom:-4px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .kS0mn{margin-bottom:-4px}}}@container (width < 640px){[dir] [data-query=container] .kS0mn{margin-bottom:-4px}}[dir] ._3LiDt{margin-bottom:24px}@media only screen and (max-width:640px){[dir] [data-query=media] ._3LiDt{margin-bottom:6px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] ._3LiDt{margin-bottom:6px}}}@container (width < 640px){[dir] [data-query=container] ._3LiDt{margin-bottom:6px}}";
var styles = {"button_colorPicker":"_-0NvO","button_colorPicker_label":"_28d-o","button_colorPicker_picker":"SAJ-g","button_colorPicker_pickerButton":"UkEEo","button_marginBottomOpenedColorPicker":"kS0mn","button_marginBottomClosedColorPicker":"_3LiDt"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ColorToggleComponent extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "onClicked", () => {
      this.props.toggle(this.props.pickerType);
      this.setState({ isOpened: !this.state.isOpened });
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.state = {
      color: props.color || "#FFF",
      isOpened: false
    };
  }
  static getDerivedStateFromProps(props, state) {
    const { color } = props;
    return color === state.color ? null : __spreadProps(__spreadValues({}, state), { color });
  }
  render() {
    const { isToggle } = this.props;
    const marginButtonClassName = isToggle ? this.styles.button_marginBottomOpenedColorPicker : this.styles.button_marginBottomClosedColorPicker;
    return /* @__PURE__ */ React.createElement("div", { className: classNames(this.styles.button_colorPicker, marginButtonClassName) }, /* @__PURE__ */ React.createElement("div", { className: this.styles.button_colorPicker_label }, this.props.children), /* @__PURE__ */ React.createElement("div", { className: this.styles.button_colorPicker_picker }, /* @__PURE__ */ React.createElement(
      "button",
      {
        style: { background: this.state.color },
        className: this.styles.button_colorPicker_pickerButton,
        onClick: this.onClicked
      }
    )));
  }
}
ColorToggleComponent.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.string,
  color: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  marginBottom: PropTypes.string,
  marginButtonClassName: PropTypes.string,
  isToggle: PropTypes.bool,
  pickerType: PropTypes.string.isRequired
};

export { ColorToggleComponent as default };
//# sourceMappingURL=color-toggle-component.js.map
